<template>
    <input type="submit" value="" class="sort asc">
</template>

<style scoped lang=scss>
    .asc {
        background-image: url("~@/assets/img/sort-20.png");
        &:hover {
            background-image: url("~@/assets/img/sort-color-20.png");
            box-shadow: inset 0 0 0 2px var(--shadow);
        }
    }
</style>

<script>
    export default {
        name: 'asc-btn',
        data() {
            return {
                
            }
        },
    }
</script>